export async function getClientIp(): Promise<string | undefined> {
  try {
    const response = await fetch('/api/get-ip');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Failed to get client IP:', error);
    return undefined;
  }
} 